import { cn } from "@/lib/utils";

function Textarea({ className, ...props }: React.ComponentProps<"textarea">) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        "w-full min-w-0 resize-y rounded-lg border border-input bg-background px-3 py-2 text-base text-foreground shadow-xs/5 outline-none ring-primary/24 transition-shadow placeholder:text-muted-foreground/72 focus-visible:border-primary focus-visible:ring-[3px] sm:text-sm dark:bg-input/32",
        className,
      )}
      {...props}
    />
  );
}

export { Textarea };
